import BaseDesignerService from '@configuratorware/configurator-frontendgui/App/Services/DesignerService';
import last from 'lodash/last';
import { alignObjectToArea, getFreePositions, rescaleObject } from "../Helpers/canvasFunctions";

export default class DesignerService extends BaseDesignerService {
  async addImageFromUrl(canvas, ...args) {
    await super.addImageFromUrl(canvas, ...args);
    this.alignAddedItem(canvas);
  }

  addText(canvas, ...args) {
    super.addText(canvas, ...args);
    this.alignAddedItem(canvas);
  }

  alignAddedItem(canvas) {
    const item = last(canvas.objects);
    const freePositions = getFreePositions(canvas.objects);
    item.userData.position = freePositions[0];
    const { size } = canvas;
    alignObjectToArea(item, size);
    rescaleObject(item, size, true);
  }
}
